import { render, staticRenderFns } from "./middleware.vue?vue&type=template&id=68b78148"
import script from "./middleware.vue?vue&type=script&lang=js"
export * from "./middleware.vue?vue&type=script&lang=js"
import style0 from "./middleware.vue?vue&type=style&index=0&id=68b78148&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports